import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppCommonModule } from './../../../common/common.module';
import { CreativeAdapter } from 'src/adapters/creative-adapter';
import { VideoListComponent } from '../creative-edit/components/video-list/video-list.component';
import { CreativeEditComponent } from './components/creative-edit/creative-edit.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CreativeOrderSummaryComponent } from './components/creative-order-summary/creative-order-summary.component';

const components = [
  CreativeEditComponent,
  VideoListComponent,
  CreativeOrderSummaryComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppCommonModule
  ],
  exports: components,
  providers: [CreativeAdapter]
})
export class CreativeEditModule { }
